<script>
export default {
  props: ["data", "addClass"],
  data() {
    return {};
  },
};
</script>
<template>
  <div class="section_galery_green bg-home--galery">
    <div class="p-md-4">
      <div class="container mt-5">
        <div class="row text-center text-lg-left">
          <div class="col-sm-8 ">
            <div class="row" v-if="data.length > 0">
              <div
                v-for="item in data.slice(0, 6)"
                :key="item.id"
                class="col-xl-4 col-lg-4 col-sm-6 col-12 p-1 "
              >
                <router-link to="#" class="gallery-item single-gallery-thumb">
                  <img :src="item.image" class="img-fluid section_galery_green_image" alt="thumbnail" />
                  <span class="span-text text-white">{{ item.title }}</span>
                </router-link>
              </div>
            </div>

            <div class="row" v-else>
              <div class="col-xl-4 col-lg-4 col-sm-6 col-12 p-1 ">
                <router-link to="#" class="gallery-item single-gallery-thumb">
                  <img
                    src="@/assets/images/global/list_empty.png"
                    class="img-fluid"
                    alt="thumbnail"
                  />
                  <span class="span-text text-white">Belum tersedia</span>
                </router-link>
              </div>
              <div class="col-xl-4 col-lg-4 col-sm-6 col-12 p-1 ">
                <router-link to="#" class="gallery-item single-gallery-thumb">
                  <img
                    src="@/assets/images/global/list_empty.png"
                    class="img-fluid"
                    alt="thumbnail"
                  />
                  <span class="span-text text-white">Belum tersedia</span>
                </router-link>
              </div>
              <div class="col-xl-4 col-lg-4 col-sm-6 col-12 p-1 ">
                <router-link to="#" class="gallery-item single-gallery-thumb">
                  <img
                    src="@/assets/images/global/list_empty.png"
                    class="img-fluid"
                    alt="thumbnail"
                  />
                  <span class="span-text text-white">Belum tersedia</span>
                </router-link>
              </div>
              <div class="col-xl-4 col-lg-4 col-sm-6 col-12 p-1 ">
                <router-link to="#" class="gallery-item single-gallery-thumb">
                  <img
                    src="@/assets/images/global/list_empty.png"
                    class="img-fluid"
                    alt="thumbnail"
                  />
                  <span class="span-text text-white">Belum tersedia</span>
                </router-link>
              </div>
              <div class="col-xl-4 col-lg-4 col-sm-6 col-12 p-1 ">
                <router-link to="#" class="gallery-item single-gallery-thumb">
                  <img
                    src="@/assets/images/global/list_empty.png"
                    class="img-fluid"
                    alt="thumbnail"
                  />
                  <span class="span-text text-white">Belum tersedia</span>
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-sm-4 information">
            <h3 class="text-color-green font-size-24">
              <span class="span-hr-green-left"></span>Galeri Foto
            </h3>
            <h3>Kumpulan foto kegiatan di lingkungan Sekolah</h3>
            <!-- <p class="font-size-15">{{ this.meta.name }} merupakan salah satu pelopor sekolah unggulan terbaik di indonesia dengan mendukung sistem pengajaran 4.0</p> -->
            <div class="text-right">
              <router-link
                to="/galeri"
                class="btn ht-btn-default--round mt-4 btn-primary-theme-green"
                >LIHAT SEMUA</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "@/assets/scss/4-sections/_galeri_2.scss";
@import "@/assets/scss/6-responsive/template-green/index.scss";
</style>
